import script from "./ReportPageWishMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportPageWishMessage.vue?vue&type=script&setup=true&lang=js"

import "./ReportPageWishMessage.vue?vue&type=style&index=0&id=f4d59d8a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4d59d8a"]])

export default __exports__